<template>
  <section class="px-[1.4286rem] md:px-0">
    <div>
      <ul class="flex flex-wrap gap-[2.1429rem]">
        <li
          v-for="(cat, i) in categories"
          :key="i"
          :class="categoryClasses(cat.active)"
        >
          <NuxtLink
            external
            :to="cat.href"
            class="hover:text-gray-900 focus:text-gray-900"
            :aria-label="cat.label"
            :title="cat.label"
            :id="`${categoryNavId}-${i}`"
            :aria-current="cat.active ? 'page' : undefined"
          >
            {{ cat.label }}
          </NuxtLink>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { CategoryLink } from "~~/shared/types/common";

const props = defineProps<{
  categories: CategoryLink[],
  id?:string
}>()

const categoryNavId = computed(() => props.id || "category-nav-id")

function categoryClasses(isActive?: boolean) {
  return [
    "text-gray-700 text-[1rem] font-normal leading-[1.3571rem] py-[1.0714rem] border-b-[0.1429rem] hover:border-gray-900 hover:text-gray-900",
    isActive ? "border-gray-900 text-gray-700" : "border-transparent"
  ]
}

</script>
